const v15 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        videosTable: {
          ...state.options.tableViews.videosTable,
          "AI Comment Sum (Positive)": true,
          "AI Comment Sum (Negative)": true,
          "AI Comment Sum (New Ideas)": true,
        },
      },
    },
  };
};

export default v15;
